// /home/szymon/kreator2/frontend/src/components/EditorOverlayWrapper.js
// v1.0.0 - Komponent do wyświetlania edytora z nakładką blokującą interakcję

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Editor from './Editor';

/**
 * Komponent opakowujący edytor z nakładką blokującą interakcję.
 * Wyświetla edytor z lekkim blurem i nakładką, która uniemożliwia interakcję.
 * Po zakończeniu autocentrowania wywołuje callback onComplete.
 */
export default function EditorOverlayWrapper({
  backendUrl,
  projectId,
  downloadKey,
  onComplete,
  onError
}) {
  const [isProcessing, setIsProcessing] = useState(true);
  const navigate = useNavigate();
  
  // Efekt do śledzenia, kiedy edytor zakończył autocentrowanie
  useEffect(() => {
    // Nasłuchujemy na zdarzenie zakończenia autocentrowania
    const handleAutoCenterComplete = (event) => {
      if (event.detail && event.detail.projectId === projectId) {
        console.log("[EditorOverlayWrapper] Otrzymano zdarzenie zakończenia autocentrowania");
        setIsProcessing(false);
        
        // Dajemy chwilę, aby zmiany zostały zapisane
        setTimeout(() => {
          console.log("[EditorOverlayWrapper] Wywołuję onComplete");
          onComplete && onComplete();
        }, 1000);
      }
    };
    
    // Dodajemy nasłuchiwanie na zdarzenie
    window.addEventListener('autocentering-complete', handleAutoCenterComplete);
    
    // Usuwamy nasłuchiwanie przy odmontowaniu
    return () => {
      window.removeEventListener('autocentering-complete', handleAutoCenterComplete);
    };
  }, [projectId, onComplete]);
  
  // Obsługa błędów
  const handleEditorError = (error) => {
    console.error("[EditorOverlayWrapper] Błąd edytora:", error);
    onError && onError(error);
  };
  
  return (
    <div className="editor-overlay-wrapper">
      {/* Nakładka blokująca interakcję */}
      <div 
        className="editor-interaction-blocker"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          backdropFilter: 'blur(2px)',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pointerEvents: 'all' // Blokuje wszystkie interakcje
        }}
      >
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          maxWidth: '400px'
        }}>
          <h3>Autocentrowanie w toku</h3>
          <p>Trwa automatyczne centrowanie pól tekstowych. Proszę czekać...</p>
          <div className="loading-spinner" style={{
            display: 'inline-block',
            width: '40px',
            height: '40px',
            margin: '10px auto',
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderRadius: '50%',
            borderTop: '4px solid #3498db',
            animation: 'spin 1s linear infinite'
          }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
      
      {/* Renderujemy pełny edytor pod nakładką */}
      <div style={{ filter: 'blur(2px)' }}>
        <Editor
          backendUrl={backendUrl}
          projectId={projectId}
          downloadKey={downloadKey}
          onError={handleEditorError}
          forceAutoCentering={true} // Wymuszamy autocentrowanie
          onAutoCenteringComplete={() => {
            // Emitujemy zdarzenie zakończenia autocentrowania
            const event = new CustomEvent('autocentering-complete', { 
              detail: { projectId } 
            });
            window.dispatchEvent(event);
          }}
        />
      </div>
    </div>
  );
}
